import { createSlice } from '@reduxjs/toolkit';
import {
  findSelectToppingsCategory,
  searchSelectToppingsCategory,
  getSelectToppingsCategory,
} from './api';
import { initialState } from './api/interface';

const selectToppingCategorySlice = createSlice({
  name: 'selectToppingCategory',
  initialState,
  reducers: {
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
    },
    setHasMore: (state, action) => {
      state.hasMore = action.payload.hasMore;
      state.status = 'idle';
    },

    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findSelectToppingsCategory.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findSelectToppingsCategory.fulfilled, (state, action) => {
      state.data.push(...action.payload.data);
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
      state.hasMore = action.payload.data.length < 10 ? false : true;
    });
    builder.addCase(findSelectToppingsCategory.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
    builder.addCase(searchSelectToppingsCategory.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(searchSelectToppingsCategory.fulfilled, (state, action) => {
      state.data = [...action.payload.data, ...state.data];
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(searchSelectToppingsCategory.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
    builder.addCase(getSelectToppingsCategory.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getSelectToppingsCategory.fulfilled, (state, _) => {
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
    });
    builder.addCase(getSelectToppingsCategory.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
    });
  },
});

export const { setSkip, setHasMore, setStatus, reset } =
  selectToppingCategorySlice.actions;
export default selectToppingCategorySlice.reducer;
